import EventEmitter from 'events';

// event事件
export const EVENTS = {
  DEFN_CLICK: 'defn-click',
  PLAYER_INITED: 'player-inited',
  EPISODE_CLICK: 'episode-click',
  CLIP_CLICK: 'clip-click',
  FIML_CLICK: 'film-click',
  INTERVAL_CLICK: 'interval_click',
  LANGUAGE_CHANGE: 'language_change',
  CUR_PAGEDATA_UPDATE: 'cur_pageData_update',
  PRELOAD_FIRSTLOAD: 'preLoad_first_load',
  PARTICULAR_INIT: 'particular_init',
  CHANGE_VIDEO: 'change_video',
  PLAY_END: 'play_end',
  HOME_PAGE_KEY_DOWN_DOWN: 'home_page_key_down_down',
  HOME_PAGE_KEY_DOWN_UP: 'home_page_key_down_up',
  HOME_PAGE_KEY_DOWN_LEFT: 'home_page_key_down_left',
  HOME_PAGE_KEY_DOWN_RIGHT: 'home_page_key_down_right',
  HOME_PAGE_KEY_DOWN_EXIT: 'home_page_key_down_exit',
  HOME_PAGE_KEY_DOWN_CLICK: 'home_page_key_down_click',
  HOME_PAGE_GET_NEXT_PAGE_DATA: 'home_page_get_next_page_data',
  HOME_PAGE_CHANGE_CHANNEL: 'home_page_change_channel',
  HOME_PAGE_RETURN_TOP: 'home_page_return_top',

  // 顶部组件登录搜索，用户信息搜索
  HEADER_INFO_KEY_DOWN_DOWN: 'header_info_key_down_down',
  HEADER_INFO_KEY_DOWN_UP: 'header_info_key_down_up',
  HEADER_INFO_KEY_DOWN_LEFT: 'header_info_key_down_left',
  HEADER_INFO_KEY_DOWN_RIGHT: 'header_info_key_down_right',
  HEADER_INFO_KEY_DOWN_CLICK: 'header_info_key_down_click',
  // 顶部组件登录搜索，用户信息搜索

  // 点播页面鼠标聚焦通知父组件改变状态
  PARTICULAR_UPDATE_STATE: 'particular_update_state',

  // 主页鼠标聚焦通知父组件改变状态
  HOME_UPDATE_STATE: 'home_update_state',
  // 点播页面鼠标聚焦通知父组件改变状态
  LIVE_COUNT_DOWN_CHANGE: 'live_count_down_change',
  ELEMENT_FOCUS: 'element_focus',
  ELEMENT_BLUR: 'element_blur',
  KEY_DOWN_DOWN: 'key_down_down',
  KEY_DOWN_UP: 'key_down_up',
  KEY_DOWN_RIGHT: 'key_down_right',
  KEY_DOWN_LEFT: 'key_down_left',
  KEY_DOWN_EXIT: 'key_down_exit',
  KEY_DOWN_CLICK: 'key_down_click',
  KEY_DOWN_PAUSE: 'key_down_pause',
  KEY_DOWN_PLAY: 'key_down_play',
  KEY_DOWN_STOP: 'key_down_stop',
  KEY_DOWN_BACK: 'key_down_back',
  KEY_DOWN_PLAY_PAUSE: 'key_down_play_pause',
  LIVE_CAMERA_CHANGE: 'live_camera_change',
  PROGRESS_BAR_CLICK: 'progress_bar_click',
  LIVE_DETAIL_GETED: 'live_detail_geted',
};

const Event = new EventEmitter();

export default Event;
